export default ({ height = 115 }) =>
    <a
        title="Clique para baixar o SumUp Bank no Google Play"
        target="_blank"
        href="https://play.google.com/store/apps/details?id=com.kaching.merchant"
    >
        <img
            alt="Disponível no Google Play"
            src="https://play.google.com/intl/en_us/badges/static/images/badges/pt-br_badge_web_generic.png"
            style={{ height: height }}
        />
    </a>
